var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewFocusedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 5.94V0H17.82V5.94H9.9ZM0 9.9V0H7.92V9.9H0ZM9.9 17.82V7.92H17.82V17.82H9.9ZM0 17.82V11.88H7.92V17.82H0ZM1.98 7.92H5.94V1.98H1.98V7.92ZM11.88 15.84H15.84V9.9H11.88V15.84ZM11.88 3.96H15.84V1.98H11.88V3.96ZM1.98 15.84H5.94V13.86H1.98V15.84Z",
    fill: "#7AC159"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewFocusedIcon);
export default __webpack_public_path__ + "static/media/overviewFocusedIcon.69240272d228ca93fd91dc1756daceae.svg";
export { ForwardRef as ReactComponent };